import type { PropsWithChildren } from "react";
import styled from "styled-components";
import { Col, Link, Row, withLink } from "@viagogo/core/ui";
import { Image } from "src/website-apps/shared/components/image";

export const ContentDivider = styled.div`
  border-bottom: 2px solid ${(props) => props.theme.colors.borderDisabled};
  max-width: 1200px;
  text-align: center;
  margin: ${(props) => props.theme.spacing(8)} auto;
  display: block;
`;

export const TextWrapper = styled.div`
  margin: ${(props) => props.theme.spacing(8)} auto;
  max-width: 1200px;
  overflow-x: hidden;
  overflow: hidden;
  display: block;
  text-align: center;
`;

export const StyledImageCol = styled(Col)`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.body1)};
  text-align: center;
  padding: ${(props) => props.theme.spacing(0, 4)};
`;

export const StyledImage = styled(Image)`
  padding: ${(props) => props.theme.spacing(4)};
`;

export const StyledTextDiv = styled.div`
  color: ${(props) => props.theme.colors.textPrimary};
  margin: ${(props) => props.theme.spacing(4, 4, 0, 4)};
  padding: ${(props) => props.theme.spacing(0, 4)};
  line-height: ${(props) => props.theme.spacing(8)};
  text-align: center;
  & a {
    color: ${(props) => props.theme.colors.textLinkPrimary};
  }
`;

export const StyledTextBodyDiv = styled(StyledTextDiv)`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.body1)};
`;

export const StyledTextHeading = styled.div`
  ${({
    theme: {
      typography: { getStyles, variant, fontWeight },
    },
  }) => getStyles(variant.body1, fontWeight.bold)};
  color: ${(props) => props.theme.colors.textPrimary};
  line-height: ${(props) => props.theme.spacing(8)};
  & a {
    color: ${(props) => props.theme.colors.textLinkPrimary};
  }
`;

export const StyledTextRow = styled(Row)`
  line-height: 32px;
  color: ${(props) => props.theme.colors.textPrimary};
  margin: ${(props) => props.theme.spacing(2, 0)};
  padding: ${(props) => props.theme.spacing(0, 2)};
  justify-content: center;
`;

export const StyledTextBodyRow = styled(StyledTextRow)`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.body1)};
`;

export const StyledImageDiv = styled.div`
  max-width: 400px;
  display: block;
  text-align: center;
  margin: 0 auto;
  padding: ${(props) => props.theme.spacing(8, 0, 12, 0)};
`;

const StyledSmallMarinImage = styled(Image)`
  margin: ${(props) => props.theme.spacing(0, 2)};
`;

export const LearnMoreLink = styled(Link)`
  color: ${(props) => props.theme.colors.textLinkPrimary};
  ${({
    theme: {
      typography: { getStyles, variant, fontWeight },
    },
  }) => getStyles(variant.body1, fontWeight.bold)};
  text-align: center;
`;

export const DownloadTitle = styled.div`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.title2)};
  padding: ${(props) => props.theme.spacing(12, 0, 10, 0)};
  text-align: center;
`;

export const DownloadContent = styled.div`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.title4)};
  margin-bottom: ${(props) => props.theme.spacing(6)};
  text-align: center;
`;

export const DownloadContentHighlight = styled(DownloadContent)`
  color: ${(props) => props.theme.colors.accent200};
`;

export const StyledImageWithLink = withLink<
  PropsWithChildren<{
    url: string;
    className?: string;
    alt?: unknown;
    size?: unknown;
    src?: unknown;
    width?: unknown;
    fallbackImageSrc?: unknown;
    allowImageSizeOverride?: unknown;
    preload?: unknown;
  }>
>(StyledSmallMarinImage);
